import { SWAP_PRODUCER, TOGGLE_PRODUCER_LIVE, TOGGLE_PRODUCER_SPOTTED, TOGGLE_PRODUCER_MENU, SET_NAME_PRODUCER, TOGGLE_PRODUCER_MUTED, SET_PARTICIPANTINFO_IN_PRODUCER} from './producersReducer';

export const toggleProducerLive = (payload) => {
  return (
    {
      type: TOGGLE_PRODUCER_LIVE,
      payload
    });
};
export const setProducerName = (payload) => {
  return (
    {
      type: SET_NAME_PRODUCER,
      payload
    });
};
export const setParticipantInProducer = (payload) => {
  return (
    {
      type: SET_PARTICIPANTINFO_IN_PRODUCER,
      payload
    });
};

export const toggleProducerSpotted = (payload) => {
  return (
    {
      type: TOGGLE_PRODUCER_SPOTTED,
      payload
    });
};
export const toggleProducerMuted = (payload) => {
  return (
    {
      type: TOGGLE_PRODUCER_MUTED,
      payload
    });
};
export const toggleProducerMenu = (payload) => {
  return (
    {
      type: TOGGLE_PRODUCER_MENU,
      payload
    });
};
export const swapProducer = (payload) => {
  return (
    {
      type: SWAP_PRODUCER,
      payload
    });
};

